import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const adminGroupRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/groups/$id',
  params: z.object({ id: zodPathParamId }),
}).lazy(() => import('pages/admin/Groups/AdminGroupPage/AdminGroupPage').then((d) => d.Route));
